export const LOGIN = "USER/LOGIN";
export const REGISTER = "USER/REGISTER";
export const LOGOUT = "USER/LOGOUT";
export const UPDATE = "USER/UPDATE";
export const LOAD_USER = "USER/LOAD";
export const LOADING_STATUS = "USER/LOADING";
